import store from '../reducers/storeRegistration';
const getUser = () => {
  const user = store.getState().login.user;
  return user || {};
};

/**
 * this returns general permissions for user.
 */
export const evaluate = async entity => {
  const user = getUser();
  return entity.appCreatorID === user.user_id;
};
export default {
  evaluate
};